(function () {
  'use strict';
  var root = document.getElementById('fwt-car');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var finder = document.getElementById('fwt-finder');
  var tyreUrl = (finder && finder.dataset.tyreUrl) || '/collections/all-tyres';
  var wheelUrl = (finder && finder.dataset.wheelUrl) || '/collections/new-wheels';
  var make = document.getElementById('fwt-car-make');
  var model = document.getElementById('fwt-car-model');
  var gen = document.getElementById('fwt-car-gen');
  var trim = document.getElementById('fwt-car-trim');
  var trimField = root.querySelector('[data-car-trim-field]');
  var out = document.getElementById('fwt-car-out');
  var TEL = '<a href="tel:+61393573411">(03) 9357 3411</a>';
  var cars = [], loading = null, run = 0;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function list(x) { if (x == null || x === '') return []; return Array.isArray(x) ? x : [x]; }
  function uniq(a) { var s = {}; return a.filter(function (x) { var k = String(x); if (s[k]) return false; s[k] = 1; return true; }); }
  function fill(sel, first, opts) {
    while (sel.options.length) sel.remove(0);
    sel.add(new Option(first, ''));
    opts.forEach(function (o) { sel.add(new Option(o[1], o[0])); });
    sel.disabled = !opts.length;
  }
  function pcdOf(x) {
    var m = String(x || '').match(/([3-8])\s*[xX\/\-]\s*(\d{3}(?:\.\d{1,2})?)/);
    return m ? m[1] + 'x' + String(Math.round(parseFloat(m[2]) * 100) / 100) : null;
  }
  function rimOf(x) { var m = String(x).match(/R(\d{2})/i); return m ? +m[1] : null; }
  function tyre(s) { return window.FWTReadTyre ? window.FWTReadTyre(s) : null; }

  /* v2 asset: {v:2, cars:[{mk, md, g, y, t, r, u, p, cb, o, fv, tr:[{n,t}], st:[[front,rear]]}]}.
     An older {vehicles:[{make, model, generation, years, trims:[...]}]} file is still accepted. */
  function normalise(doc) {
    if (doc && doc.v === 2) return doc.cars || [];
    var rows = Array.isArray(doc) ? doc : (doc && doc.vehicles) || [];
    return rows.map(function (v) {
      var tr = list(v.trims), all = [], up = [];
      tr.forEach(function (t) { all = all.concat(list(t.tyre_sizes)); up = up.concat(list(t.popular_upgrade_sizes).map(function (u) { return u && u.size || u; })); });
      var o = v.offset_range || (tr[0] && tr[0].offset_range);
      return { mk: v.make, md: v.model, g: v.generation || '', y: v.years || '', t: uniq(list(v.tyre_sizes_all).concat(all)), u: uniq(up),
        p: v.pcd || (tr[0] && tr[0].pcd), cb: v.centre_bore_mm || (tr[0] && tr[0].centre_bore_mm), fv: v.fully_verified ? 1 : 0,
        o: o && o.aftermarket_et_min != null ? [o.aftermarket_et_min, o.aftermarket_et_max] : null,
        tr: tr.length > 1 ? tr.map(function (t) { return { n: t.name, t: list(t.tyre_sizes) }; }) : null };
    }).filter(function (c) { return c.mk && c.md; });
  }
  function genLabel(c) {
    var y = String(c.y || '').replace(/-on$|-$/, ' on').replace('-', '–');
    if (c.g && y) return y + ' · ' + c.g;
    return c.g || y || 'All years';
  }
  function sortTxt(a, b) { return a[1].localeCompare(b[1], 'en', { numeric: true }); }

  function makes() {
    fill(make, 'Choose make', uniq(cars.map(function (c) { return c.mk; })).map(function (m) { return [m, m]; }).sort(sortTxt));
  }
  function models() {
    var ms = uniq(cars.filter(function (c) { return c.mk === make.value; }).map(function (c) { return c.md; }));
    fill(model, 'Choose model', make.value ? ms.map(function (m) { return [m, m]; }).sort(sortTxt) : []);
    fill(gen, 'Choose year', []);
    hideTrim(); show(null);
  }
  function gens() {
    var gs = [];
    cars.forEach(function (c, i) { if (c.mk === make.value && c.md === model.value) gs.push([String(i), genLabel(c), c.y]); });
    gs.sort(function (a, b) { return String(b[2]).localeCompare(String(a[2])); });
    fill(gen, 'Choose year', model.value ? gs : []);
    hideTrim(); show(null);
    if (gs.length === 1) { gen.value = gs[0][0]; trims(); }
  }
  function hideTrim() { trimField.hidden = true; fill(trim, 'All versions', []); }
  function trims() {
    var c = cars[+gen.value];
    if (!gen.value || !c) { hideTrim(); show(null); return; }
    if (c.tr && c.tr.length > 1) {
      fill(trim, 'All versions', c.tr.map(function (t, i) { return [String(i), t.n]; }));
      trim.disabled = false;
      trimField.hidden = false;
    } else hideTrim();
    show(c);
  }

  function tyreLinks(sizes, rearOf) {
    return sizes.map(function (s) {
      var t = tyre(s);
      if (!t) return '';
      return '<li><a class="fwt-car__link" href="' + esc(tyreUrl + '/' + t.handle) + '">' + esc(t.label) + '</a></li>';
    }).join('');
  }
  function stagLinks(pairs) {
    return pairs.map(function (p) {
      var f = tyre(p[0]), r = tyre(p[1]);
      if (!f || !r) return '';
      return '<li><a class="fwt-car__link fwt-car__link--pair" href="' + esc(tyreUrl + '/' + f.handle + '?rs=' + encodeURIComponent(r.label)) + '"><small>Front</small>' + esc(f.label) + '<small>Rear</small>' + esc(r.label) + '</a></li>';
    }).join('');
  }
  function group(h, body) { return '<div class="fwt-car__group"><p class="fwt-car__h">' + h + '</p>' + body + '</div>'; }

  function show(c) {
    var my = ++run;
    if (!c) { out.innerHTML = ''; return; }
    var t = c.tr && trim.value !== '' && c.tr[+trim.value];
    var sizes = t ? t.t : c.t;
    var name = esc(c.mk + ' ' + c.md);
    var html = '';
    var tl = tyreLinks(sizes);
    html += group('Tyre sizes for your ' + name + (t ? ' <span>' + esc(t.n) + '</span>' : ''), tl ? '<ul class="fwt-car__links">' + tl + '</ul>' : '<p class="fwt-car__meta">Call us on ' + TEL + ' and we will confirm your size.</p>');
    var st = (c.st || []).filter(function (p) { return !t || (t.t.indexOf(p[0]) >= 0 && t.t.indexOf(p[1]) >= 0); });
    if (st.length) html += group('Different front and rear sizes', '<ul class="fwt-car__links">' + stagLinks(st) + '</ul>');
    var ul = tyreLinks(list(c.u));
    if (ul) html += group('Popular upgrade sizes', '<ul class="fwt-car__links">' + ul + '</ul><p class="fwt-car__meta">Upgrades can need a lift or wheel change. Ask us before you buy.</p>');
    html += '<div class="fwt-car__group" data-car-wheels>' + wheelsHtml(c, null) + '</div>';
    if (!c.fv) html += '<p class="fwt-car__note">Check your tyre placard (driver\'s door) to confirm size.</p>';
    out.innerHTML = html;
    var pcd = pcdOf(c.p);
    if (!pcd || !window.FWTWheelData) return;
    window.FWTWheelData.load(wheelUrl).then(function (ps) {
      if (my !== run) return;
      var box = out.querySelector('[data-car-wheels]');
      if (box) box.innerHTML = wheelsHtml(c, ps);
    }).catch(function () {
      if (my !== run) return;
      var box = out.querySelector('[data-car-wheels]');
      if (box) box.innerHTML = wheelsHtml(c, []);
    });
  }
  function wheelsHtml(c, ps) {
    var h = 'Wheels that fit';
    var pcd = pcdOf(c.p);
    var order = '<p class="fwt-car__order">We can order wheels for your car — call ' + TEL + '</p>';
    if (!pcd) return group(h, order);
    var meta = ['Stud pattern ' + esc(pcd)];
    if (c.o) meta.push('offset guide ' + (c.o[0] > 0 ? '+' : '') + c.o[0] + ' to ' + (c.o[1] > 0 ? '+' : '') + c.o[1]);
    var cb = c.cb ? '<p class="fwt-car__meta">Centre bore ' + esc(c.cb) + ' mm – hub rings may be needed</p>' : '';
    if (!ps) return group(h, '<p class="fwt-car__meta" aria-busy="true">Checking wheels in stock...</p>');
    var D = window.FWTWheelData, byRim = {}, styles = {};
    ps.forEach(function (p) {
      p.v.forEach(function (v) {
        if (!D.matches(v, { pcd: pcd })) return;
        styles[p.h] = 1;
        (byRim[v.rim] = byRim[v.rim] || {})[p.h] = 1;
      });
    });
    var total = Object.keys(styles).length;
    if (!total) return group(h, order + '<p class="fwt-car__meta">' + meta.join(' · ') + '</p>' + cb);
    var want = uniq(list(c.r).concat(list(c.u).map(rimOf)).filter(Boolean)).sort(function (a, b) { return a - b; });
    var links = '';
    want.forEach(function (r) {
      var n = byRim[r] ? Object.keys(byRim[r]).length : 0;
      if (!n) return;
      links += '<li><a class="fwt-car__link" href="' + esc(wheelUrl + '?view=fwt-wheels&pcd=' + encodeURIComponent(pcd) + '&rim=' + r) + '">' + r + '" wheels<small>' + n + (n === 1 ? ' style' : ' styles') + '</small></a></li>';
    });
    links += '<li><a class="fwt-car__link fwt-car__link--quiet" href="' + esc(wheelUrl + '?view=fwt-wheels&pcd=' + encodeURIComponent(pcd)) + '">All ' + esc(pcd) + ' wheels<small>' + total + (total === 1 ? ' style' : ' styles') + '</small></a></li>';
    var noRim = want.length && !want.some(function (r) { return byRim[r]; });
    return group(h, (noRim ? '<p class="fwt-car__meta">None in your factory rim size right now — call ' + TEL + ' and we will order them in.</p>' : '') + '<ul class="fwt-car__links">' + links + '</ul><p class="fwt-car__meta">' + meta.join(' · ') + '</p>' + cb);
  }

  make.addEventListener('change', models);
  model.addEventListener('change', gens);
  gen.addEventListener('change', trims);
  trim.addEventListener('change', function () { show(cars[+gen.value] || null); });
  [make, model, gen, trim].forEach(function (s) {
    s.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); var a = out.querySelector('a'); if (a) a.focus(); } });
  });

  /* load the car list only when someone reaches for the car finder */
  function load() {
    if (loading) return loading;
    make.options[0].text = 'Loading cars...';
    loading = fetch(root.dataset.src, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (doc) {
        cars = normalise(doc); var keep = make.value; makes(); make.disabled = false;
        if (keep) { make.value = keep; models(); }
        preset();
      })
      .catch(function () { loading = null; make.options[0].text = 'Choose make'; out.innerHTML = '<p class="fwt-car__meta">The car list could not load. Call us on ' + TEL + '.</p>'; });
    if (window.FWTWheelData) setTimeout(function () { window.FWTWheelData.load(wheelUrl).catch(function () {}); }, 400);
    return loading;
  }
  /* ?car=Toyota|Kluger (from a header search for a car name) picks that car */
  var want = (new URLSearchParams(location.search).get('car') || '').split('|');
  function preset() {
    if (!want[0]) return;
    var mk = want[0], md = want[1] || '';
    want = [''];
    if (![].some.call(make.options, function (o) { return o.value === mk; })) return;
    make.value = mk; models();
    if (md && [].some.call(model.options, function (o) { return o.value === md; })) { model.value = md; gens(); }
    (md ? gen : model).focus({ preventScroll: true });
  }
  if (want[0]) {
    load();
    var jump = function () { root.scrollIntoView({ block: 'start' }); };
    if (document.readyState === 'complete') jump(); else window.addEventListener('load', jump);
  }
  ['focusin', 'pointerenter', 'touchstart', 'mousedown'].forEach(function (ev) { root.addEventListener(ev, load, { once: true, passive: true }); });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); } }, { rootMargin: '0px 0px -10% 0px' });
    io.observe(root);
  }
})();
